
const MandatoryStar = () => {

    return (
        <div style={{ display: 'flex', alignItems: 'baseline', margin: "0.5rem 0" }}>
            <span style={{ color: 'red' }}>*</span>
            <div style={{ color: 'gray', fontSize: '0.7rem' }}>notwendige Angaben</div>
        </div>
    )
}

export default MandatoryStar
